<script lang="ts">
	import { Label } from "flowbite-svelte-v1";
	import EditImage from "#lib/components/images/EditImage.svelte";
	import { AGENT_IMAGE_ASPECT_RATIO } from "#lib/components/images/constants.js";
	import type { ImagePickerChangeEvent } from "#lib/components/images/types.js";
	import type { ComponentEditingProps } from "#lib/components/page/ComponentProps.js";
	import EditorInset from "#lib/components/page/editing/EditorInset.svelte";
	import { sentenceCase } from "#lib/string.js";
	import { setStringValue, setStructValue, stringValue, structValue } from "#lib/struct.js";
	import type { JsonValue } from "@bufbuild/protobuf";

	let { id, page, onChange }: ComponentEditingProps = $props();

	let lastError: unknown = $state();

	const src = $derived(stringValue(structValue($page.config, id), "src"));

	export function validate(): boolean {
		return true;
	}

	function update(e: CustomEvent<ImagePickerChangeEvent>) {
		let config = structValue($page.config, id);
		if (!config) {
			config = {};
			setStructValue($page.config, id, config);
		}
		setStringValue(config, "src", e.detail.value);
		$page = $page;
		onChange?.(e.detail as unknown as JsonValue);
	}
</script>

<EditorInset>
	<div class="flex flex-col gap-2 px-6">
		<Label for={id} class="text-gray-900">{sentenceCase(id)}</Label>
		<EditImage class="w-48" imgClass="aspect-square rounded-lg" bind:error={lastError} value={src} on:change={update} aspectRatio={AGENT_IMAGE_ASPECT_RATIO} />
	</div>
</EditorInset>
